import { Button, Col, Row, Typography } from 'antd';
import React from 'react';
import settlement from '../services/settlement';

interface Props {
  rowData: any;
  count: number;
  selectedRow: React.Key[];
  page: number;
  fromDt: string;
  toDt: string;
  filterState: string;
  filter: string;
  filterInput: string;
  sort: boolean;
}

const LogisticsCenterList = ({
  rowData,
  count,
  selectedRow,
  page,
  fromDt,
  toDt,
  filterState,
  filter,
  filterInput,
  sort
}: Props) => {
  const handleOnExport = async () => {
    if (selectedRow.length > 0) {
      const response = await settlement.exportLogisticsCenterExcellById(
        selectedRow
      );
      const outputFilename = `Logistics_Center_${new Date().toJSON().slice(0,10)}.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    } else {
      const response = await settlement.exportLogisticsCenterExcell(
        page,
        fromDt,
        toDt,
        filterState,
        filter,
        filterInput,
        sort
      );
      const outputFilename = `Logistics_Center_${new Date().toJSON().slice(0,10)}.xlsx`;

      const url = URL.createObjectURL(new Blob([response]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();
    }
  };
  return (
    <div className="busk-sellerSubHead">
      <Row align="middle">
        <Col flex="auto">
          <Row gutter={15}>
            <Col>
              <Typography.Text>총 완료 거래 {count ?? '00'}</Typography.Text>
            </Col>
            <Col>|</Col>
            <Col>
              <Typography.Text>
                선택 완료 거래 {selectedRow.length || '00'}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
        <Col>
          <Button
            style={{
              color: 'gray'
            }}
            onClick={() => handleOnExport()}
          >
            엑셀 다운로드
          </Button>
        </Col>
      </Row>
    </div>
  );
};

export default LogisticsCenterList;
